import React from 'react';
import { HRInsights } from '@/api/types';
import { FormatText } from '@/components/ui/FormatText';
import { CheckCircle2 } from 'lucide-react';

interface HRInsightsTabProps {
  insights: HRInsights;
}

export function AnalysisHRInsightsTab({ insights }: HRInsightsTabProps) {
  return (
    <div className="space-y-6">
      <div className="p-6 border border-slate-300 dark:border-slate-800 rounded-xl bg-white dark:bg-slate-900 dark:shadow-sm">
        <h3 className="text-xs font-bold uppercase tracking-wider text-slate-600 dark:text-slate-400 mb-3 flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-slate-400"></span>
          The 6-Second Screen
        </h3>
        <p className="text-sm font-medium text-slate-800 dark:text-slate-200 leading-relaxed border-l-2 border-slate-300 dark:border-slate-700 pl-4 ml-1">
          <FormatText text={insights.sixSecondTest} />
        </p>
      </div>
      
      <div className="p-6 border border-rose-200 dark:border-rose-900/50 rounded-xl bg-rose-50 dark:bg-rose-950/20 dark:shadow-sm">
        <h3 className="text-xs font-bold uppercase tracking-wider text-rose-700 dark:text-rose-400 mb-4 flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse"></span>
          Red Flags
        </h3>
        {insights.redFlags.length === 0 ? (
           <p className="text-sm font-medium text-emerald-700 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/20 p-3 rounded-lg flex items-center gap-2">
             <CheckCircle2 className="w-4 h-4"/> None detected. Good job!
           </p>
        ) : (
          <ul className="space-y-3">
            {insights.redFlags.map((flag, i) => (
              <li key={i} className="flex gap-3 text-sm font-medium text-rose-800 dark:text-rose-300 leading-relaxed">
                <span className="text-rose-400 dark:text-rose-500 shrink-0 mt-0.5">•</span>
                <span><FormatText text={flag} /></span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="p-6 border border-slate-300 dark:border-slate-800 rounded-xl bg-white dark:bg-slate-900 dark:shadow-sm">
        <h3 className="text-xs font-bold uppercase tracking-wider text-emerald-600 dark:text-emerald-400 mb-3 flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
          Culture & Tone Fit
        </h3>
        <p className="text-sm font-medium text-slate-800 dark:text-slate-200 leading-relaxed">
          <FormatText text={insights.cultureFit} />
        </p>
      </div>
    </div>
  );
}
